export default "__VITE_ASSET__DlpKjNjI__"